<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <v-card-text class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
        </div>

        <v-form ref="addEmployeeForm" lazy-validation>
          <v-text-field
            :label="'lng_name_text' | translate"
            v-model="employeeName"
            :rules="[rules.required]"
          ></v-text-field>
          
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn
              :loading="showLoading"
              color="#0B7894"
              dark
              @click="validate"
            >{{ "lng_save_txt" | translate }}</v-btn>
          </div>
        </v-form>        

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { translateFunc } from '../../common/Filters';
import GlobalService from "../../services/global-service";

export default {
  name: "AddEmployee",
  data() {
    return {
      dialog: false,
      employeeName: "",
      showLoading: false,
      rules: {
        required: value => !!value || translateFunc("lng_required_text"),
      },
      error: ""
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    dealerToken: {
      type: String,
      default: ""
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  },
  mounted() {},
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.addEmployeeForm.validate()) {
          this.saveNewEmployee();
        }
      });
      // this.openBoxModal = true;
    },
    async saveNewEmployee(){
      let response = await GlobalService.addNewEmployee(this.dealerToken, this.employeeName);
      if(response.status === 0){
        this.$emit("saveSuccess")
        this.closeDialog();
      } else {
        this.error = response.msg
      }
    }
  }
};
</script>
<style scoped>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
</style>
